import { render } from "./HomeIcon.vue?vue&type=template&id=59040d64&scoped=true&ts=true"
import script from "./HomeIcon.vue?vue&type=script&lang=ts"
export * from "./HomeIcon.vue?vue&type=script&lang=ts"

import "./HomeIcon.vue?vue&type=style&index=0&id=59040d64&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59040d64"]])

export default __exports__